import { Api } from "../config/request";

export default {
  getNamespaces(payload) {
    return Api.get("/feature-config/namespace?limit=1000");
  },
  getKeys(namespace) {
    return Api.get(`/feature-config/keys?namespace=${namespace}`);
  },
  filterKeyConfigs(payload) {
    return Api.post("/feature-config/filter", payload);
  },
  upsertConfig(payload) {
    return Api.post("/feature-config/upsert", payload);
  },
  getNamespace(namespace) {
    return Api.get("/feature-config/namespace/" + namespace);
  },
  getUploadUrl(payload) {
    return Api.post("/feature-config/presign-url", payload);
  },
  getUser(email) {
    return Api.get(`/feature-config/user?email=${email}`)
  },
  upsertUser(payload){
    return Api.post("/feature-config/upsert-user", payload);
  }
};
